const state = {
    coupons: [],
    users: [],
};

const getters = {
    coupons: state => state.coupons,
    users: state => state.users
};

const actions = {
};

const mutations = {
    all(state, coupons) {
        state.coupons = coupons
    },
    users(state, users) {
        state.users = users
    }
};

export default {
    namespaced: true,
    getters,
    state,
    actions,
    mutations,
};
